export default "__VITE_ASSET__BDwzequp__"